import {ActionBuilder} from "co-redux-builders";

export default ActionBuilder.build({
    setPageNumber: (page: number) => ({page}),
    setSort: (asc: boolean, column: string) => ({asc, column}),
    setSearch: (search: string) => ({search}),
});